
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlist/most-popular",
      function () {
        return require("private-next-pages/playlist/most-popular.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlist/most-popular"])
      });
    }
  